import React from 'react';
import PropTypes from 'prop-types';
import {downloadBuckarooConnectionAgreementFile,fetchSenderOnboarding} from "../services";
import Fetch from "../Elements/Fetch";
import SenderOnboardingDownloadConnectionAgreementForm from "./SenderOnboardingDownloadConnectionAgreementForm";

const SenderOnboardingDownloadConnectionAgreementRoute = ({match, history, onSubmit}) => {
    return (
        <Fetch fetchFunction={fetchSenderOnboarding} fetchFunctionParams={match.params.id}>
            {senderOnboarding => {
                const handleAction = async (language) => {
                    await downloadBuckarooConnectionAgreementFile(senderOnboarding.id, language);
                    onSubmit();
                };

                return (
                    <SenderOnboardingDownloadConnectionAgreementForm
                        senderOnboarding={senderOnboarding}
                        onAction={handleAction}
                    />
                );
            }}
        </Fetch>
    );
};

SenderOnboardingDownloadConnectionAgreementRoute.propTypes = {
    onSubmit: PropTypes.func,
};

export default SenderOnboardingDownloadConnectionAgreementRoute;